var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0833 22C9.09619 22 1 13.9038 1 3.91667C1 3.46608 1.01648 3.01934 1.04887 2.57702C1.08604 2.06939 1.10463 1.81558 1.23765 1.58453C1.34783 1.39318 1.54308 1.2117 1.74198 1.11579C1.98211 1 2.26219 1 2.82234 1H6.10921C6.58026 1 6.81579 1 7.01769 1.07753C7.19604 1.14601 7.35485 1.25724 7.48016 1.40145C7.62201 1.5647 7.7025 1.78605 7.86349 2.22874L9.22395 5.97006C9.4112 6.48512 9.50488 6.74265 9.48902 6.98698C9.47502 7.20243 9.4014 7.40976 9.27657 7.5859C9.135 7.78566 8.90003 7.92665 8.43007 8.20862L6.83333 9.16667C8.23555 12.2571 10.7418 14.7666 13.8333 16.1667L14.7914 14.57C15.0734 14.0999 15.2143 13.865 15.4141 13.7234C15.5902 13.5986 15.7975 13.525 16.013 13.511C16.2573 13.4951 16.5149 13.5888 17.03 13.7761L20.7713 15.1365C21.2139 15.2975 21.4353 15.378 21.5985 15.5199C21.7427 15.6452 21.8541 15.804 21.9224 15.9823C22 16.1842 22 16.4197 22 16.8908V20.1777C22 20.7378 22 21.0179 21.8842 21.258C21.7883 21.4569 21.6068 21.6522 21.4155 21.7624C21.1844 21.8954 20.9306 21.9139 20.423 21.9511C19.9806 21.9836 19.5339 22 19.0833 22Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c08d936f1a9809004a69c291944e0d06.svg";
export { ForwardRef as ReactComponent };